var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaunchpads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.57129,
    y: 1.6001,
    width: 29.8571,
    height: 28.8,
    rx: 2,
    fill: "#242424"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.71436,
    y: 4.7124,
    width: 5.68966,
    height: 5.85163,
    rx: 1,
    fill: "#48DEFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.71436,
    y: 13.075,
    width: 5.68966,
    height: 5.85163,
    rx: 1,
    fill: "#00FF66"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.71436,
    y: 21.4312,
    width: 5.68966,
    height: 5.85163,
    rx: 1,
    fill: "#FF9A03"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6548,
    y: 4.7124,
    width: 5.68966,
    height: 5.85163,
    rx: 1,
    fill: "#FF6107"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6548,
    y: 13.075,
    width: 5.68966,
    height: 5.85163,
    rx: 1,
    fill: "#FF2AEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6548,
    y: 21.4312,
    width: 5.68966,
    height: 5.85163,
    rx: 1,
    fill: "#3661FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5972,
    y: 4.7124,
    width: 5.68967,
    height: 5.85163,
    rx: 1,
    fill: "#BD00FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5972,
    y: 13.075,
    width: 5.68967,
    height: 5.85163,
    rx: 1,
    fill: "#DBFF00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5972,
    y: 21.4312,
    width: 5.68967,
    height: 5.85163,
    rx: 1,
    fill: "#BFD7EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpads);
export default __webpack_public_path__ + "static/media/launchpads.82ab431c2c0e1150fc3255098b1f16db.svg";
export { ForwardRef as ReactComponent };